"use client";

import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { MdLogout, MdPerson } from "react-icons/md";
import { useAuth } from "@/context/AuthContext";
import Button from "@/components/ui/Button";
import type { UserProfileProps } from "@/types";
import { useEVMiStore } from "@/store/EVMStoreProvder";

export default function UserProfile({ 
  className = "",
  showWelcomeText = true,
  avatarBgColor = "bg-brand-blue",
  avatarTextColor = "text-white"
}: UserProfileProps) {
  const { user, logout, isAuthenticated } = useAuth();
  const router = useRouter();
  const [showLogout, setShowLogout] = useState(false);
  const [mounted, setMounted] = useState(false);

  const clearEVMiStore = useEVMiStore((state) => state.clearEVMiStore);
  useEffect(() => {
    setMounted(true);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      clearEVMiStore();
      router.push("/signin");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  if (!mounted || !user || !isAuthenticated) return null;

  return (
    <div className={`flex items-center gap-3 relative ${className}`}>
      <button
        id="user-profile"
        className={`p-2 rounded-full ${avatarBgColor} ${avatarTextColor} cursor-pointer`}
        onClick={() => setShowLogout(!showLogout)}
        aria-label="User profile menu"
      >
        <MdPerson className="w-5 h-5" />
      </button>
      
      {showWelcomeText && (
        <label className="text-base md:text-lg font-bold hidden sm:block cursor-pointer" htmlFor="user-profile">
          Welcome, {user?.firstname ? `${user.firstname} ${user.lastname}` : 'User'}
          <span className="text-xs text-gray-500 block mt-2 ravi">({user?.roleRef?.displayName})</span>
        </label>
      )}
      
      {showLogout && (
        <div className="absolute top-full right-0 mt-2 bg-white rounded-full shadow-lg border border-gray-200 p-2 min-w-[120px] z-50">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            leftIcon={<MdLogout className="w-4 h-4" />}
            className="!w-full !justify-start !text-left !text-sm !text-gray-700 hover:!bg-gray-100"
          >
            Logout
          </Button>
        </div>
      )}
    </div>
  );
}
